import { useCallback, useMemo } from "react"

import useList from "./useList"

export default function useTypesList({ definition: { types } = {} } = {}) {
  const { add, remove, list } = useList(types)

  const handleAdd = useCallback(name => add({
    name,
    templates: [],
    isNew: true,
  }), [add])

  return useMemo(() => ({
    list,
    add: handleAdd,
    remove,
  }), [list, handleAdd, remove])
}
